<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_v"></a>Contents</h1>
<h2 class="tocf"><a href="#/xhtml/04_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc"><a href="#/xhtml/05_Chapter1"><span class="tocpad"><span class="bold">Chapter 1</span></span> British/Welsh Kings</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter2" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 2</span></span> Hengest, ‘King Stallion/Gelding’: Founder Of Kent. Did He Ever Exist?</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter3" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 3</span></span> Cerdic of Wessex: Man of Mystery</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter4" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 4</span></span> Early Mercia – An ‘Anglian’ Kingdom? Partly British, and a Welsh Not An English Ally?</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter5" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 5</span></span> Bernicia, Deira And Early Northumbria: Another Kingdom Of Mixed Heritage?</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter6" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 6</span></span> Known Unknowns? Some Missing Or Garbled Royal Details</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter7" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 7</span></span> The Odd Ones Out?</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter8" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 8</span></span> Was the Creation of One Kingdom of England a Dynastic Accident?</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter9" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 9</span></span> Three Major Royal Murders – And Cover-Ups?</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample"><span class="tocpad"><span class="bold">Chapter 10</span></span> The Succession In 1066: Were The Claims Of William Of Normandy Invented Or Irrelevant?</span></h2>
<h2 class="tocf1"><span href="#/xhtml/15_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="tocf"><span href="#/xhtml/16_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?1b4d8336